import { Body, Button, Sheet, VStack } from '@hover/blueprint';
import React from 'react';

import {
  HomeownerAppMenuNames,
  useHomeownerAppContext,
} from 'src/modules/homeownerApp/hooks/useHomeownerAppContext';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const ShareSheet = () => {
  const { setCurrentMenu } = useHomeownerAppContext();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <Sheet.Contents header={t('share.header')}>
      <Body color="neutral.600">{t('share.subHeader')}</Body>
      <VStack align="stretch" py="500" spacing="400">
        <Button
          label="sign-up-or-login"
          onClick={() => setCurrentMenu(HomeownerAppMenuNames.SIGN_IN)}
          textDecoration="none"
          variant="primary"
        >
          {t('share.buttonText')}
        </Button>
        <Button
          label="no-save"
          onClick={() => setCurrentMenu()}
          variant="ghost"
        >
          {t('share.cancel')}
        </Button>
      </VStack>
    </Sheet.Contents>
  );
};

export { ShareSheet };
